import { PublicKey } from '@solana/web3.js';

export const PROGRAM_ID = new PublicKey('GZ5jTA4KNr6qv72VUEfg1RmEnYB4htGLKSZbMmsia5MD');
export const GLOBAL_CONFIG_SEED = 'config';
export const GLOBAL_DUMP_VAULT_SEED = 'dump_vault';
